import type { ZodError } from 'zod'

export class LocationError extends Error {
  override name = 'LocationError'
}

export class LocationNotFoundError extends LocationError {
  constructor(
    public readonly criteria: {
      id?: number
      customerId?: number
      customerRef?: string
      placeId?: string
    }
  ) {
    super(`Location not found: ${JSON.stringify(criteria)}`)
    this.name = 'LocationNotFoundError'
  }
}

export class LocationValidationError extends LocationError {
  constructor(public readonly zodError: ZodError) {
    super(`Location validation failed: ${zodError.message}`)
    this.name = 'LocationValidationError'
  }
}

export class GeocodingError extends LocationError {
  constructor(
    public readonly address: string,
    public readonly reason: string
  ) {
    super(`Geocoding failed for "${address}": ${reason}`)
    this.name = 'GeocodingError'
  }
}

export class AmbiguousLocationError extends LocationError {
  constructor(
    public readonly candidates: Array<{ id: number; name: string; score: number }>
  ) {
    super(`Multiple candidate locations found. User selection required.`)
    this.name = 'AmbiguousLocationError'
  }
}
